import { User } from 'iconsax-reactjs';
import { FC, useState } from 'react';
import { getFileUrl } from '@/utils/file';
import { StyledAvatar } from './styled';

type Props = {
  className?: string;
  name?: string | null;
  size?: number;
}

const Avatar: FC<Props> = ({ name, size = 70, className }) => {
  const [isError, setError] = useState(false);

  const url = name ? getFileUrl(name) : null;

  return (
    <StyledAvatar $size={size} className={className}>
      {url && !isError ? (
        <img
          src={url}
          alt="Avatar"
          onError={() => setError(true)}
        />
      ) : (
        <User
          size="32"
          color="var(--color-white)"
          variant="Bold"
        />
      )}
    </StyledAvatar>
  );
};

export default Avatar;